module.exports = __webpack_public_path__ + "assets/fancybox.27afc3d7.svg";